export default {
  // 默认配置
  default: {
    request: [
      {
        // 超级营销通用
        baseURL: '/', // 服务端接口地址base
      },
    ],
    apps: {
      '/web/crm': {
        entry: '//127.0.0.1:32200/index.html',
      },
      '/web/customdata': {
        entry: '//127.0.0.1:8080/index.html',
        // version: 'https://subapps.dianpusoft.cn/customdata/version.txt',
        // entry: 'https://subapps.dianpusoft.cn/customdata/index.html',
        // resources: [
        //   "https://subapps.dianpusoft.cn/customdata/js/index.js",
        //   "https://subapps.dianpusoft.cn/customdata/css/index.css"
        // ],
      },
    },
  },

  // 联调环境配置
  uat: {
    apps: {
      '/web/crm': {
        entry: '/web/crm/index.html',
      },
      '/web/customdata': {
        entry: 'https://subapps-test.dianpusoft.cn/customdata/index.html',
        version: 'https://subapps-test.dianpusoft.cn/customdata/version.txt',
        // resources: [
        //   `https://subapps-test.dianpusoft.cn/customdata/js/index.js`,
        //   `https://subapps-test.dianpusoft.cn/customdata/css/index.css`,
        // ],
      },
    },
  },
  // 正式环境配置
  prod: {
    apps: {
      '/web/crm': {
        entry: '/web/crm/index.html',
      },
      '/web/customdata': {
        // entry: 'https://subapps.dianpusoft.cn/customdata/index.html',
        version: 'https://subapps.dianpusoft.cn/customdata/version.txt',
        resources: [
          'https://subapps.dianpusoft.cn/customdata/js/index.js',
          'https://subapps.dianpusoft.cn/customdata/css/index.css',
        ],
      },
    },
  },
};
